import Component from '@bythepixel/component-loader';

const DEFAULTS = {
  activeLinkClass: 'section-sub-nav__link--current',
  marker: '[data-sub-nav-marker]',
  subNavLinks: 'section-sub-nav__link',
  sections: '[data-sub-nav-section]',
  modalId: 'data-sub-nav-modal-id',
};

export default class SubNav extends Component {
  static selector = '[data-comp-sub-nav]';

  constructor(el, options = DEFAULTS) {
    super(el, options);
    this.links = el.querySelectorAll(`.${options.subNavLinks}`);
    this.marker = el.querySelector(options.marker);
    this.modalId = el.getAttribute(options.modalId);
    this.sections = document.querySelectorAll(options.sections);
    this.currentLink = el.querySelector(`.${options.activeLinkClass}`);

    this.observeSections = entries => {
      const entry = entries[0];
      // Once it's within 105px of the top of the scrollable area, set the nav item to active
      if (entry.isIntersecting) {
        const sectionId = entry.target.id;
        this.currentLink = this.$container.querySelector(`[href="#${sectionId}"]`);
        this.events();
      }
    };
    this.observer = new IntersectionObserver(this.observeSections, {
      threshold: 0,
      rootMargin: '-1% 0% -90% 0%',
    });

    this.init();
  }

  init() {
    const { hash } = window.location;
    const section = document.getElementById(hash.substring(1, hash.length));

    if (section) {
      section.scrollIntoView();
    }

    this.clickEvents();
    this.observeViewport();
  }

  clickEvents() {
    this.links.forEach(link => {
      link.addEventListener('click', e => {
        // Workaround for a bug in chrome, this prevents a scroll bug that is caused by anchor links and the intersection observerAPI
        e.preventDefault();
        const { href } = link;
        const hash = href.substring(href.indexOf('#'), href.length);
        let id = hash.substring(1, hash.length);
        id = decodeURIComponent(id);

        // Temporarily stop observing so the click event can dictate the active link
        this.unobserveViewport();

        // Don't append hashes for modals
        if (!this.modalId) {
          window.history.replaceState(null, null, `${window.location.pathname}${hash}`);
        }

        this.currentLink = this.$container.querySelector(`[href="#${id}"]`);
        document.getElementById(id).scrollIntoView();
        this.styleLinks();
        this.moveMarker();

        setTimeout(() => {
          this.observeViewport();
        }, 500); // Gives enough time for the window to scroll before observing again
      });
    });
  }

  events() {
    if (this.currentLink) {
      this.styleLinks();
      this.moveMarker();
      this.subNavScroll();
    }
  }

  moveMarker() {
    setTimeout(() => {
      if (!this.marker || !this.currentLink) {
        return;
      }

      const { offsetLeft, offsetWidth } = this.currentLink;

      this.marker.style.left = `${offsetLeft}px`;
      this.marker.style.width = `${offsetWidth}px`;
    }, 200);
  }

  observeViewport() {
    this.sections.forEach(section => {
      this.observer.observe(section);
    });
  }

  unobserveViewport() {
    this.sections.forEach(section => {
      this.observer.unobserve(section);
    });
  }

  styleLinks() {
    this.currentLink.classList.add(this.$options.activeLinkClass);
    this.links.forEach(link => {
      if (link !== this.currentLink && link.classList.contains(this.$options.activeLinkClass)) {
        link.classList.remove(this.$options.activeLinkClass);
      }
    });
  }

  subNavScroll() {
    setTimeout(() => {
      if (!this.currentLink) {
        return;
      }

      const { offsetWidth, offsetLeft } = this.currentLink;
      const innerWidth = this.$container.offsetWidth;
      const halfWindowWidth = innerWidth / 2;
      const modalCloseWidth = this.modalId ? 56 : 0;
      const offsetRight = offsetLeft + offsetWidth;

      // If this instance is in a modal, the scroll happens on the component container,
      // otherwise the scroll is happening on the component's parent container
      const scrollTargetEl = this.modalId ? this.$container : this.$container.parentElement;

      if (offsetLeft > halfWindowWidth) {
        const linkCenter = (innerWidth - offsetWidth - modalCloseWidth) / 2;
        const scrollAmount = offsetRight - linkCenter;
        scrollTargetEl.scroll({
          left: scrollAmount,
          behavior: 'smooth',
        });
      } else {
        scrollTargetEl.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }
    }, 500); // Needed to prevent conflicts with the click to scroll functionality
  }
}
